/**
 * Returns a human-readable "time ago" string for a given ISO date.
 * @param {string|Date} inputDate
 * @returns {string}
 */
export function timeAgo(inputDate) {
  // ✅ Guard clause FIRST
  if (!inputDate) return "-";

  const date = new Date(inputDate);

  // ✅ Handle invalid date explicitly
  if (isNaN(date.getTime())) return "-";

  const now = new Date();
  const diff = (now - date) / 1000; // seconds

  if (diff < 5) return "Just now";
  if (diff < 60) return `${Math.floor(diff)} seconds ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)} minutes ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} hours ago`;

  // Yesterday check
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);

  if (
    date.getDate() === yesterday.getDate() &&
    date.getMonth() === yesterday.getMonth() &&
    date.getFullYear() === yesterday.getFullYear()
  ) {
    return "Yesterday";
  }

  return date.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
}

// Example usage:
// timeAgo("2025-04-29T07:43:49.000000Z") // "April 29,

/**
 * Formats a bid date to "Oct 30th, 2025, 11:30 PM" style
 * @param {string|Date} dateString
 * @returns {string}
 */
export function formatBidDateTime(dateString) {
  const date = new Date(dateString);

  const options = {
    month: "short", // "Oct"
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  };

  const formatted = date.toLocaleString("en-US", options);

  // Add ordinal suffix to the day
  const day = date.getDate();
  const suffix =
    day % 10 === 1 && day !== 11
      ? "st"
      : day % 10 === 2 && day !== 12
      ? "nd"
      : day % 10 === 3 && day !== 13
      ? "rd"
      : "th";

  return formatted.replace(new RegExp(`\\b${day}\\b`), `${day}${suffix}`);
}

// Example usage:
// formatBidDateTime("2025-10-30T23:30:00Z") -> "Oct 30th, 2025, 11:30 PM"
